const content = {
  component: 'FrontCover',
  cssClass: 'page-one',
  meta: {
    title: 'Your Tomorrow, Today',
    description: 'Your Tomorrow, Today is a magazine about innovation. We tell the stories of companies who push the envelope',
    og: {
      type: 'website',
      title: 'Discover stories of innovation—read now',
      description: `in terms of what’s possible, utilising the latest technology to realise their strategic visions. Read issue 1 now, 
        and be inspired to grow your own business.`,
      image: require('../../assets/images/social/og_home.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Discover inspiring stories of how real businesses are innovating.',
      description: `Welcome to the first issue of Your Tomorrow, Today—a magazine all about business innovation. Discover stories of 
        how technology enables companies to grow, and be inspired to evolve your own business.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_home.jpg')
    }
  },
  chip: 'Issue 01',
  title: 'Your Tomorrow, <strong>Today</strong>',
  subtitle: 'Stories of innovative and forward-looking businesses solving tomorrow’s issues today.',
  ctaCopy: 'Get started',
  heroImage: {
    preload: require('../../assets/images/backgrounds/page-one-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/page-one.jpg')
  }
}

export default content;